import {
  treeItem,
  setTreeAction,
  TREE_TYPE,
  setTreeLoadingAction,
} from './treeReducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_TREEALLDATA_API } from '../../api/CommonApi'
import { GetLocalStorage } from '../../tools/util'

function* alltask() {
  yield takeEvery(TREE_TYPE.GET_TREE_DATA, getTreeData)
}

// 获取tree数据
function* getTreeData(action: any): any {
  yield put(setTreeLoadingAction(true))
  const resData = yield GET_TREEALLDATA_API({
    cooperateType: action.value ?? GetLocalStorage('COOPERATETYPE'),
  })
  yield put(setTreeLoadingAction(false))
  const { code, data } = resData
  if (code === 0) {
    const treedata: treeItem[] = (data || []).filter(
      (item: any) => item.name !== '技术服务',
    )
    const action = setTreeAction(treedata)
    yield put(action)
  }
}

// 导出当前模块的saga处理方法
export default function* treesagas() {
  yield all([fork(alltask)])
}
import {
  treeItem,
  setTreeAction,
  TREE_TYPE,
  setTreeLoadingAction,
} from './treeReducer'
import { takeEvery, put, all, fork } from 'redux-saga/effects'
import { GET_TREEALLDATA_API } from '../../api/CommonApi'
import { GetLocalStorage } from '../../tools/util'

function* alltask() {
  yield takeEvery(TREE_TYPE.GET_TREE_DATA, getTreeData)
}

// 获取tree数据
function* getTreeData(action: any): any {
  yield put(setTreeLoadingAction(true))
  const resData = yield GET_TREEALLDATA_API({
    cooperateType: action.value ?? GetLocalStorage('COOPERATETYPE'),
  })
  yield put(setTreeLoadingAction(false))
  const { code, data } = resData
  if (code === 0) {
    const treedata: treeItem[] = (data || []).filter(
      (item: any) => item.name !== '技术服务',
    )
    const action = setTreeAction(treedata)
    yield put(action)
  }
}

// 导出当前模块的saga处理方法
export default function* treesagas() {
  yield all([fork(alltask)])
}
